import React from 'react';
import { ADDON_CATALOG, isAddonEnabled } from '../../utils/addons';
import { useAddons } from '../../hooks/useAddon';

const AddonsPanel = () => {
  const { loaded, addons } = useAddons();

  return (
    <section className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-4">
      <h3 className="text-lg font-semibold text-gray-900">Add-ons</h3>
      <p className="text-sm text-gray-600 mb-3">Managed by your CRM provider.</p>
      {!loaded ? (
        <p role="status">Loading add-ons...</p>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
          {ADDON_CATALOG.map(addon => (
            <div key={addon.key} className="border border-gray-200 rounded-lg p-3 min-w-0">
              <h4 className="font-semibold text-gray-900">{addon.name}</h4>
              <span className={`text-xs font-medium ${isAddonEnabled(addons, addon.key) ? 'text-green-800' : 'text-gray-600'}`}>
                {isAddonEnabled(addons, addon.key) ? 'Enabled' : 'Disabled'}
              </span>
              <p className="text-sm text-gray-600 mt-1 break-words">{addon.description}</p>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default AddonsPanel;
